do ->

    angular
        .module 'fundersclub.funds', [
            'ngAnimate'
            'fundersclub.models'
            'ngSanitize'
            'highcharts-ng'
        ]
